import type {
	ActivityTriggerCapture,
	ActivityTriggerValueCapability
} from "./types";

export interface FieldAdapterHooks<TValue> {
	hasValue(): boolean;
	resolveValue(capture: ActivityTriggerCapture): TValue | PromiseLike<TValue>;
	onTriggered(value: TValue): void;
}

export abstract class FieldAdapter<TValue> implements ActivityTriggerValueCapability {
	constructor(private readonly hooks: FieldAdapterHooks<TValue>) {
	}

	get hasValue(): boolean {
		return this.hooks.hasValue();
	}

	captureValue(capture: ActivityTriggerCapture): TValue | PromiseLike<TValue> {
		return this.hooks.resolveValue(capture);
	}

	applyCapturedValue(value: unknown): void {
		// The coordinator applies each captured value back to the same verified controller capability.
		this.hooks.onTriggered(value as TValue);
	}
}
